module.exports = __webpack_public_path__ + "img/logo.3202efdc.svg";